export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11626.35d97f59.jpg";